import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import VerticalInsights from "CurriculumInsights/routes/VerticalInsights";
import GenericInsightsView from "CurriculumInsights/routes/GenericInsightsView";
import Manage from "CurriculumInsights/routes/Manage";

export default store => ({
  path: ":yearGroupId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "year-group" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    VerticalInsights(store),
    Manage(store),
    GenericInsightsView(store),
  ],
});
